module.exports = __webpack_public_path__ + "static/media/progressCard.3ea0bfcf.svg";